import React from 'react';
import './ProjectCard.css';

const ProjectCard = ({ project }) => {
  return (
    <a  href={`/project/${[project.pid]}`}className="card shadow-lg flex flex-row h-[40dvh]">
      <img className='m-[4%] w-[40%]' src="building-icon.png" alt="Project Icon" />
      <div className="m-[5%] flex flex-col justify-evenly">
        <div className="text-left text-[#03236F] text-2xl font-semibold">{project.sector_p}</div>
        <div className="text-left text-gray-600">{project.User.company_name}</div>
        <div className="text-lg text-gray-600 text-left flex flex-row items-center gap-[3%]"><img className='h-5' src='duration.png' alt="" />{project.duration_l} years</div>
        <div className="flex items-center text-left text-gray-600 text-lg gap-[3%]"><img className='h-5' src='location.png' alt="" />{project.project_size}
          <div className='text-lg text-gray-600 text-left flex flex-row items-center gap-[3%]'>
            <img className='h-5' src="location0.png" alt="" />
            {project.location}
            </div>
        </div>
        <div className="text-lg text-left">{project.project_desc}</div>
      </div>
    </a>
  );
};

export default ProjectCard;
